export class User {
  id = '';
  oid = '';
  email = '';
  name = '';
  languageCode = 'en-GB';
  role: USER_ROLE;
  expire?: Date;

  constructor(args?: User) { }
}

export enum USER_ROLE {
  INTERNAL = 'INTERNAL_USER',
  EXTERNAL = 'EXTERNAL_USER',
}
